import React, { useContext } from 'react'
import Input from '../../../components/Input'
import { EditingKnowledgeDispatch } from '..'
import './KQuestionSection.css'
import { StatusValidIcon } from '../../../conf/images'

interface KQuestionSectionProps {
    onSimilar?: () => void
    value?: string
    status?: number
    simiarShow?: boolean
    disabled?: boolean
    similarDisable?: boolean
    statusShow?: boolean
}
const KQuestionSection: React.FC<KQuestionSectionProps> = (props) => {
    const {
        onSimilar = () => undefined,
        value,
        similarDisable = true,
        disabled,
        status,
        simiarShow = true,
        statusShow = false,
    } = props
    const { dispatch } = useContext(EditingKnowledgeDispatch)
    return (
        <div className='k-question-section'>
            <div className='title'>
                <p className='h-title'>问题</p>
                {simiarShow && (
                    <p
                        className={`similar-btn ${
                            similarDisable ? 'disable' : ''
                        }`}
                        onClick={() => {
                            !similarDisable && onSimilar()
                        }}
                    >
                        管理相似问
                    </p>
                )}
                {statusShow && status !== undefined && (
                    <span
                        className='knowledge-status'
                        onClick={() =>
                            dispatch({
                                type: 'updateKnowledgeStatus',
                            })
                        }
                    >
                        {status === 1 ? (
                            <img
                                className='status-active'
                                src={StatusValidIcon}
                                alt='active'
                            />
                        ) : (
                            <span className='status-circle'></span>
                        )}
                        <span
                            className={`status-text ${
                                status === 1 ? 'active' : ''
                            }`}
                        >
                            生效
                        </span>
                    </span>
                )}
            </div>
            {disabled && <p>{value}</p>}
            {!disabled && (
                <Input
                    placeholder='请输入问题'
                    multiple
                    maxLength={500}
                    onChange={(value) =>
                        dispatch({
                            type: 'updateKnowledge',
                            payload: value,
                        })
                    }
                    disabled={disabled}
                    value={value}
                />
            )}
        </div>
    )
}

export default KQuestionSection
